/** Default post-login landing for all staff — My Inbox. */
export const DEFAULT_LANDING_ROUTE = "/notification-center";

export const HOME_BREADCRUMB_ITEM = {
  label: "Home",
  path: DEFAULT_LANDING_ROUTE,
};
